<template>
    <div id="app">
        <v-app  id="inspire" style="background: #CFD8DC">
            <v-container>
                <v-layout>
                    <h4 class="subheading font-weight-medium">WEBSITE</h4>
                    <v-spacer></v-spacer>
                    <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                </v-layout>
          
                <!-- <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs6>
                    <v-card class="mx-auto elevation-1" max-width="500px">
                        <v-toolbar color="white" class="elevation-0">
                            <v-icon>dehaze</v-icon>
                            <v-toolbar-title class="subheading font-weight-bold">Slides</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-divider></v-divider>
                    
                        <v-container fluid>
                            <v-carousel height="300px">
                                <v-carousel-item v-for="(item,i) in gallery" :key="i" :src="item.src"></v-carousel-item>
                            </v-carousel>
                        </v-container>
                    </v-card>
                    </v-flex>

                    <v-flex xs6>
                    <v-card class="mx-auto elevation-1" max-width="500px">
                        <v-toolbar color="white" class="elevation-0">
                            <v-icon>dehaze</v-icon>
                            <v-toolbar-title class="subheading font-weight-bold">New Slide</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-divider></v-divider>
                    
                        <v-container fluid>
                            <v-flex xs12>
                                <v-text-field label="Title" outline required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea label="Description" outline required></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Link" outline required></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-card>
                    </v-flex>
                </v-layout>
                </v-container> -->
            </v-container>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
import { stage } from '../../appConfig';
export default {
    data() {
        return {
            gallery: [
                {src: require('../img/01_slides.png')},
                {src: require('../img/02_slides.png')},
                {src: require('../img/03_slides.png')},
                {src: require('../img/04_slides.png')},
                {src: require('../img/05_slides.png')},
            ],
        }
    },

    mounted() {
        let self = this
        // *********** S E R V I C E  M E N U ***************        
        db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
            querySnapshot.forEach(function(doc){
                db.collection("ServiceMenu"+self.$stage).doc(doc.data().id).update({
                    category: ""
                })
            })
        }).catch(function(error){
            console.log(error)
        })

        // *********** B R A N C H  U S E R S ***************        
        db.collection("branchUsers"+self.$stage).get().then(function(querySnapshot){
            querySnapshot.forEach(function(doc){
                db.collection("Branches"+self.$stage).where("branchCode","==",doc.data().branchCode)
                .get().then(function(branchResult) {
                    branchResult.forEach(function(result){
                        db.collection("branchUsers"+self.$stage).doc(doc.data().email).update({
                            branchId: result.data().id
                        }).catch(function(error){
                            console.log(error)
                        })
                    })
                }).catch(function(error){
                    console.log(error)
                })
            })
        }).catch(function(error){
            console.log(error)
        })

        // ************ M E C H A N I C S **************
        db.collection("Mechanics"+self.$stage).get().then(function(querySnapshot){
            querySnapshot.forEach(function(doc){
                db.collection("Branches"+self.$stage).where("branchCode","==",doc.data().branchCode)
                .get().then(function(branchResult) {
                    branchResult.forEach(function(result){
                        db.collection("Mechanics"+self.$stage).doc(doc.data().id).update({
                            branchId: result.data().id
                        }).catch(function(error){
                            console.log(error)
                        })
                    })
                }).catch(function(error){
                    console.log(error)
                })
            })
        }).catch(function(error){
            console.log(error)
        })

        // ************ C A L E N D A R  M A N A G E M E N T **************
        db.collection("Events"+self.$stage).get().then(function(querySnapshot){
            querySnapshot.forEach(function(doc){
                db.collection("Branches"+self.$stage).where("branchCode","==",doc.data().branch.split('_')[0].trim())
                .get().then(function(branchResult) {
                    branchResult.forEach(function(result){
                        db.collection("Events"+self.$stage).doc(doc.data().Id).update({
                            branchId: result.data().id
                        }).catch(function(error){
                            console.log(error)
                        })
                    })
                }).catch(function(error){
                    console.log(error)
                })
            })
        }).catch(function(error){
            console.log(error)
        })

        // ************ S E R V I C E  B O O K I N G **************
        db.collection("ServiceBooking"+self.$stage).get().then(function(querySnapshot){
            querySnapshot.forEach(function(doc){
                db.collection("Branches"+self.$stage).where("branchCode","==",doc.data().branchCode)
                .get().then(function(branchResult) {
                    branchResult.forEach(function(result){
                        db.collection("ServiceBooking"+self.$stage).doc(doc.data().transactionId).update({
                            branchId: result.data().id
                        }).catch(function(error){
                            console.log(error)
                        })
                    })
                }).catch(function(error){
                    console.log(error)
                })
            })
        }).catch(function(error){
            console.log(error)
        })
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>

</style>